const swiper = new Swiper('.js-navigation-usps', {
    // Rewind avoids loop reordering around the hidden Customer Club slide.
    loop: false,
    rewind: true,
    effect: "slide",
    direction: "vertical",
    speed: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 200,
    slidesPerView: 1,
    centeredSlides: true,
    autoplay: {
        delay: 1800,
        disableOnInteraction: false,
    }
});

// The basket keeps exact prices; USP amounts use whole currency units.
const formatNavigationShippingUsp = (message) => message.replace(
   /(\d[\d.]*),(\d{2})(?=\s+[A-Z]{3}\b)/g,
   (_, whole, fraction) => String(Number(whole.replace(/\./g, '')) + (Number(fraction) > 0 ? 1 : 0))
)

const updateNavigationShippingUsp = () => {
   const basketMessage = document.querySelector(
      '#js-mini-basket [data-navigation-shipping-message]'
   )
   const hasItems = Number(document.getElementById('js-mini-basket')?.dataset.lineCount || 0) > 0
   const message = formatNavigationShippingUsp(basketMessage?.textContent.replace(/\s+/g, ' ').trim() || '')

   document.querySelectorAll('.js-navigation-shipping-usp-text').forEach((target) => {
      target.textContent = message
      target.closest('.navigation__usp').hidden = !message
   })

   if(hasItems && message && swiper && typeof swiper.slideToLoop === 'function') {
      swiper.autoplay?.stop()
      swiper.slideToLoop(0, 0, false, true)
   } else {
      swiper.autoplay?.start()
   }
}

updateNavigationShippingUsp()
document.addEventListener('kabooki:minibasket:updated', updateNavigationShippingUsp)
document.addEventListener('kabooki:club-usp:shown', updateNavigationShippingUsp)

const openMegaClass = "navigation__mega--open"
const visibleMegaClass = "navigation__mega--visible"
const closingMegaClass = "navigation__mega--closing"
const scrollableMegaClass = "navigation__mega--scrollable"
const navigationMegaOpenClass = "navigation--mega-open"
const menu = document.querySelector(".navigation__menu")
const navigation = document.querySelector(".js-navigation")
const desktopMenuMedia = window.matchMedia("(min-width: 985px)")
const reducedMotionMedia = window.matchMedia("(prefers-reduced-motion: reduce)")
const megaCloseDelay = 300
const megaTransitionDuration = 300
let megaCloseTimer
let megaTransitionTimer

const updateMegaMenuOverflow = (megaMenu) => {
   if(!megaMenu || !desktopMenuMedia.matches) return

   const navigationHeight = Math.ceil(navigation?.getBoundingClientRect().height || 0)
   megaMenu.style.setProperty('--navigation-shell-height', `${navigationHeight}px`)
   megaMenu.classList.toggle(
      scrollableMegaClass,
      megaMenu.scrollHeight > megaMenu.clientHeight + 1
   )
}

const updateOpenMegaMenuOverflow = () => {
   document.querySelectorAll(`.navigation__mega.${openMegaClass}`).forEach(
      updateMegaMenuOverflow
   )
}

const updateMobileHeaderOffset = () => {
   if(!navigation) return
   const desktopUsp = navigation.querySelector('.navigation__usps--desktop')
   navigation.style.setProperty('--desktop-usp-height', `${desktopUsp?.getBoundingClientRect().height || 0}px`)
   document.documentElement.style.setProperty(
      '--mobile-header-offset',
      `${navigation.getBoundingClientRect().height}px`
   )
}

const updateMobileViewportBottomOffset = () => {
   const viewport = window.visualViewport
   const activeElement = document.activeElement
   const keyboardInputActive = activeElement && (
      activeElement.matches('input, textarea, select') ||
      activeElement.isContentEditable
   )

   if(!viewport || keyboardInputActive || Math.abs(viewport.scale - 1) > 0.01) {
      document.documentElement.style.setProperty('--mobile-viewport-bottom-offset', '0px')
      return
   }

   const layoutHeight = document.documentElement.clientHeight
   const bottomOffset = Math.max(
      0,
      Math.round(layoutHeight - viewport.height - viewport.offsetTop)
   )
   document.documentElement.style.setProperty(
      '--mobile-viewport-bottom-offset',
      `${bottomOffset}px`
   )
}

updateMobileHeaderOffset()
updateMobileViewportBottomOffset()
window.addEventListener('resize', updateMobileHeaderOffset, { passive: true })
window.addEventListener('resize', updateMobileViewportBottomOffset, { passive: true })
window.visualViewport?.addEventListener('resize', updateMobileViewportBottomOffset, { passive: true })
window.visualViewport?.addEventListener('scroll', updateMobileViewportBottomOffset, { passive: true })
document.addEventListener('focusin', updateMobileViewportBottomOffset)
document.addEventListener('focusout', () => window.setTimeout(updateMobileViewportBottomOffset, 120))
if(navigation && typeof ResizeObserver !== 'undefined') {
   new ResizeObserver(updateMobileHeaderOffset).observe(navigation)
}

const initialiseBasketCountAnimation = () => {
   const basketButton = document.querySelector(".navigation__basket")
   if(!basketButton || typeof MutationObserver === "undefined") return

   let previousCount = basketButton
      .querySelector(".navigation__basket-count")?.textContent.trim() || ""

   const animateCurrentCount = () => {
      const count = basketButton.querySelector(".navigation__basket-count")
      const nextCount = count?.textContent.trim() || ""

      if(!count || !nextCount || nextCount === previousCount) {
         previousCount = nextCount
         return
      }

      previousCount = nextCount
      count.classList.remove("navigation__basket-count--animate")
      void count.offsetWidth
      count.classList.add("navigation__basket-count--animate")
      count.addEventListener("animationend", () => {
         count.classList.remove("navigation__basket-count--animate")
      }, { once: true })
   }

   new MutationObserver(animateCurrentCount).observe(basketButton, {
      childList: true,
      characterData: true,
      subtree: true,
   })
}

initialiseBasketCountAnimation()

const mobileLayerMedia = window.matchMedia('(max-width: 984px)')
let mobileLayerScrollY = 0
let mobileLayerLockFrame

const syncMobileLayerLock = () => {
   window.cancelAnimationFrame(mobileLayerLockFrame)
   mobileLayerLockFrame = window.requestAnimationFrame(() => {
      const hasOpenLayer = mobileLayerMedia.matches && Boolean(document.querySelector(
         '.mobile-info-panel.is-open, .mobile-favourites-panel.is-open, .mini-basket--active, .wishlist-auth.is-open, .mobile-shop-switch.is-open'
      ))
      const isLocked = document.body.classList.contains('mobile-layer-open')

      if(hasOpenLayer && !isLocked) {
         mobileLayerScrollY = window.scrollY
         document.body.style.top = `-${mobileLayerScrollY}px`
         document.body.classList.add('mobile-layer-open')
         return
      }

      if(!hasOpenLayer && isLocked) {
         document.body.classList.remove('mobile-layer-open')
         document.body.style.removeProperty('top')
         window.scrollTo(0, mobileLayerScrollY)
      }
   })
}

window.KabookiSyncMobileLayerLock = syncMobileLayerLock
window.addEventListener('resize', syncMobileLayerLock, { passive: true })

const mobileFavouritesPanel = document.getElementById('mobile-favourites-panel')
const mobileFavouritesTrigger = document.querySelector('.js-mobile-favourites-trigger')
const mobileFavouritesBackdrop = document.querySelector('.mobile-favourites-panel__backdrop')

const setMobileFavouritesOpen = (open) => {
   if(!mobileFavouritesPanel || !mobileFavouritesTrigger || !mobileFavouritesBackdrop) return

   mobileFavouritesPanel.classList.toggle('is-open', open)
   mobileFavouritesBackdrop.classList.toggle('is-open', open)
   mobileFavouritesPanel.setAttribute('aria-hidden', open ? 'false' : 'true')
   mobileFavouritesTrigger.setAttribute('aria-expanded', open ? 'true' : 'false')
   mobileFavouritesTrigger.classList.toggle('is-active', open)
   syncMobileLayerLock()

   if(open) {
      document.dispatchEvent(new CustomEvent('kabooki:mobile-layer-open', {
         detail: { layer: 'favourites' }
      }))
   }
}

mobileFavouritesTrigger?.addEventListener('click', () => {
   if(!document.getElementById('js-primary-wishlist')) {
      window.location.href = '/user-wishlists'
      return
   }
   setMobileFavouritesOpen(!mobileFavouritesPanel.classList.contains('is-open'))
})

document.querySelectorAll('.js-mobile-favourites-close').forEach((button) => {
   button.addEventListener('click', () => setMobileFavouritesOpen(false))
})

document.addEventListener('kabooki:mobile-layer-open', (event) => {
   if(event.detail?.layer !== 'favourites') setMobileFavouritesOpen(false)
})

document.addEventListener('keydown', (event) => {
   if(event.key === 'Escape') setMobileFavouritesOpen(false)
})

const mobileInfoPanel = document.getElementById('mobile-info-panel')
const mobileInfoTrigger = document.querySelector('.js-mobile-info-trigger')
const mobileInfoBackdrop = document.querySelector('.mobile-info-panel__backdrop')
const mobileInfoLoginToggle = document.querySelector('.js-mobile-info-login-toggle')
const mobileInfoLogin = document.getElementById('mobile-info-login')
const mobileInfoServiceToggle = document.querySelector('.js-mobile-info-service-toggle')
const mobileInfoServiceLinks = document.getElementById('mobile-info-service-links')

const setMobileInfoServiceOpen = (open) => {
   if(!mobileInfoServiceToggle || !mobileInfoServiceLinks) return
   mobileInfoServiceLinks.hidden = !open
   mobileInfoServiceToggle.setAttribute('aria-expanded', open ? 'true' : 'false')
}

const setMobileInfoLoginOpen = (open) => {
   if(!mobileInfoLoginToggle || !mobileInfoLogin) return
   mobileInfoLogin.hidden = !open
   mobileInfoLoginToggle.setAttribute('aria-expanded', open ? 'true' : 'false')
   mobileInfoLoginToggle.classList.toggle('is-open', open)
   setMobileInfoServiceOpen(!open)
   if(open) mobileInfoLogin.querySelector('input[type="email"]')?.focus()
}

const setMobileInfoOpen = (open) => {
   if(!mobileInfoPanel || !mobileInfoTrigger || !mobileInfoBackdrop) return

   mobileInfoPanel.classList.toggle('is-open', open)
   mobileInfoBackdrop.classList.toggle('is-open', open)
   mobileInfoPanel.setAttribute('aria-hidden', open ? 'false' : 'true')
   mobileInfoTrigger.setAttribute('aria-expanded', open ? 'true' : 'false')
   mobileInfoTrigger.classList.toggle('is-active', open)
   syncMobileLayerLock()

   if(!open) {
      setMobileInfoLoginOpen(false)
      setMobileInfoServiceOpen(true)
   }

   if(open) {
      document.dispatchEvent(new CustomEvent('kabooki:mobile-layer-open', {
         detail: { layer: 'info' }
      }))
   }
}

mobileInfoTrigger?.addEventListener('click', () => {
   setMobileInfoOpen(!mobileInfoPanel.classList.contains('is-open'))
})

mobileInfoLoginToggle?.addEventListener('click', () => {
   setMobileInfoLoginOpen(mobileInfoLogin.hidden)
})

mobileInfoServiceToggle?.addEventListener('click', () => {
   setMobileInfoServiceOpen(mobileInfoServiceLinks.hidden)
   if(!mobileInfoServiceLinks.hidden) setMobileInfoLoginOpen(false)
})

document.querySelectorAll('.js-mobile-info-close').forEach((button) => {
   button.addEventListener('click', () => setMobileInfoOpen(false))
})

document.addEventListener('kabooki:mobile-layer-open', (event) => {
   if(event.detail?.layer !== 'info') setMobileInfoOpen(false)
})

document.addEventListener('keydown', (event) => {
   if(event.key === 'Escape') setMobileInfoOpen(false)
})

const mobileShopSwitch = document.getElementById('mobile-shop-switch')
const mobileShopSwitchContinue = document.querySelector('.js-shop-switch-continue')

const setMobileShopSwitchOpen = (open, targetUrl = '') => {
   if(!mobileShopSwitch || !mobileShopSwitchContinue) return
   if(targetUrl) mobileShopSwitchContinue.href = targetUrl
   mobileShopSwitch.classList.toggle('is-open', open)
   mobileShopSwitch.setAttribute('aria-hidden', open ? 'false' : 'true')
   syncMobileLayerLock()

   if(open) {
      document.dispatchEvent(new CustomEvent('kabooki:mobile-layer-open', {
         detail: { layer: 'shop-switch' }
      }))
      mobileShopSwitchContinue.focus()
   }
}

document.querySelectorAll('.js-shop-switch').forEach((link) => {
   link.addEventListener('click', (event) => {
      if(link.getAttribute('aria-current') === 'page') {
         event.preventDefault()
         return
      }
      const basketCount = Number.parseInt(
         document.querySelector('.navigation__basket-count')?.textContent || '0',
         10
      )
      const miniBasketLines = Number.parseInt(
         document.getElementById('js-mini-basket')?.dataset.lineCount || '0',
         10
      )
      const hasBasketItems = link.dataset.basketHasItems === 'true' ||
         basketCount > 0 || miniBasketLines > 0
      if(!hasBasketItems) return

      event.preventDefault()
      setMobileInfoOpen(false)
      setMobileShopSwitchOpen(true, link.href)
   })
})

document.querySelectorAll('.js-shop-switch-close').forEach((button) => {
   button.addEventListener('click', () => setMobileShopSwitchOpen(false))
})

document.addEventListener('kabooki:mobile-layer-open', (event) => {
   if(event.detail?.layer !== 'shop-switch') setMobileShopSwitchOpen(false)
})

document.addEventListener('keydown', (event) => {
   if(event.key === 'Escape') setMobileShopSwitchOpen(false)
})

document.querySelector('.mobile-dock__basket')?.addEventListener('click', (event) => {
   event.preventDefault()
   event.stopPropagation()

   if(window.KabookiMiniBasket) {
      window.KabookiMiniBasket.toggle()
      return
   }

   window.location.href = '/basket'
})

const clearMegaTimers = () => {
   window.clearTimeout(megaCloseTimer)
   window.clearTimeout(megaTransitionTimer)
}

const finaliseMegaClose = () => {
   document.querySelectorAll(`.${openMegaClass}`).forEach((item) => {
      item.classList.remove(openMegaClass, visibleMegaClass, closingMegaClass)

      const icon = item.querySelector("span")
      if(icon && icon.innerText == "-") icon.innerText = "+"
   })

   document.body.classList.remove("mega-open")
   navigation?.classList.remove(navigationMegaOpenClass)
}

const closeOpenMenus = ({ animate = false, keepHeader = false } = {}) => {
   window.clearTimeout(megaTransitionTimer)

   const openMegaMenus = document.querySelectorAll(
      `.navigation__mega.${openMegaClass}`
   )
   const shouldAnimate = animate && desktopMenuMedia.matches &&
      !reducedMotionMedia.matches && openMegaMenus.length

   if(!shouldAnimate) {
      document.querySelectorAll(`.${openMegaClass}`).forEach((item) => {
         item.classList.remove(openMegaClass, visibleMegaClass, closingMegaClass)

         const icon = item.querySelector("span")
         if(icon && icon.innerText == "-") icon.innerText = "+"
      })

      if(!keepHeader) finaliseMegaClose()
      return
   }

   openMegaMenus.forEach((megaMenu) => {
      megaMenu.classList.remove(visibleMegaClass)
      megaMenu.classList.add(closingMegaClass)
   })

   megaTransitionTimer = window.setTimeout(
      finaliseMegaClose,
      megaTransitionDuration
   )
}

const openMegaMenu = (trigger, megaMenu) => {
   clearMegaTimers()

   if(!trigger.classList.contains(openMegaClass)) {
      closeOpenMenus({ keepHeader: true })
      trigger.classList.add(openMegaClass)
      megaMenu.classList.add(openMegaClass)
   }

   megaMenu.classList.remove(closingMegaClass)
   document.body.classList.add("mega-open")
   navigation?.classList.add(navigationMegaOpenClass)
   updateMegaMenuOverflow(megaMenu)

   window.requestAnimationFrame(() => {
      megaMenu.classList.add(visibleMegaClass)
      window.requestAnimationFrame(() => updateMegaMenuOverflow(megaMenu))
   })
}

window.addEventListener('resize', updateOpenMegaMenuOverflow, { passive: true })

if(typeof ResizeObserver !== 'undefined') {
   const megaMenuResizeObserver = new ResizeObserver((entries) => {
      entries.forEach(({ target }) => {
         if(target.classList.contains(openMegaClass)) updateMegaMenuOverflow(target)
      })
   })

   document.querySelectorAll('.navigation__mega').forEach((megaMenu) => {
      megaMenuResizeObserver.observe(megaMenu)
   })
}

const megaTriggers = document.querySelectorAll('.js-navigation-trigger-mega').forEach((item) => {
   item.addEventListener("click", (event) => {

      const icon = item.querySelector("span")
      if(icon) icon.innerText = icon.innerText == "+" ? "-" : "+"

      if(!item.classList.contains(openMegaClass)) {
         event.preventDefault()
         openMegaMenu(item, item.nextElementSibling)
      } else {
         closeOpenMenus({ animate: desktopMenuMedia.matches })
         return
      }
   })

   const menuItem = item.closest("li");
   const megaMenu = item.nextElementSibling;

   if(menuItem && megaMenu) {
      menuItem.addEventListener("mouseenter", () => {
         if(!desktopMenuMedia.matches) return;

         openMegaMenu(item, megaMenu)
      });

      menuItem.addEventListener("mouseleave", () => {
         if(!desktopMenuMedia.matches) return;

         window.clearTimeout(megaCloseTimer)
         megaCloseTimer = window.setTimeout(() => {
            closeOpenMenus({ animate: true })
         }, megaCloseDelay)
      });
   }
})

window.addEventListener("click", (event) => {
   if(!event.target.closest(`.${openMegaClass}`)) {
      if(event.target.nodeName === "A") return;
      clearMegaTimers()
      closeOpenMenus()
   }
})

const navtrigger = document.querySelector(".js-navigation-trigger-mobile");
if(navtrigger) {

   navtrigger.addEventListener("click", () => {
      document.body.classList.toggle("mobile-nav-open");
      navtrigger.classList.toggle("navigation__trigger--open");
      document.querySelector(".navigation__menu").classList.toggle("navigation__menu--open");
   })
}

let lastScroll = 0;

const checkScrollDirection = () => {
   const scroll = window.scrollY;
   if(scroll > lastScroll && scroll > 150) {
      navigation.classList.add("navigation--down");
   } else {
      navigation.classList.remove("navigation--down");
   }
   lastScroll = scroll;
}

window.addEventListener("scroll", () => {
   if(navigation) {

      if(window.scrollY > 0) {
         navigation.classList.add("navigation--scrolled");
         navigation.classList.contains("navigation--front") && navigation.classList.remove("navigation--transparent");
      } else {
         navigation.classList.remove("navigation--scrolled");
         navigation.classList.contains("navigation--front") && navigation.classList.add("navigation--transparent");
      }

      checkScrollDirection();
   }
})

